var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MenuItem, Stack, TextField } from "@mui/material";
import { ContainerForm } from "../../../components/ContainerForm";
import { ContainerLayout } from "../../../components/ContainerLayout";
import { FixedMenu } from "../../../components/FixedMenu";
import { FormButton, FormButtonType } from "../../../components/FormButton";
import { HorizontalStepper } from "../../../components/HorizontalStepper";
import { Modal } from "../../../components/Modal";
import { SnackbarFeedback } from "../../../components/SnackbarFeedback";
import { TituloPagina } from "../../../components/TituloPagina";
import { useAuth } from "../../../hooks/useAuth";
import { obterCidades } from "../../../services/generico.service";
import { obterDadosCondutor } from "../../../services/habilitacao.service";
import { formatarCpf, formatarTelefone } from "../../../util/mascaras";
import { AlterarEndereco } from "../AlterarEndereco";
var steps = ["Dados da Solicitação", "Confirmação"];
export var PidRequest = function () {
    var userInfo = useAuth().userInfo;
    var navigate = useNavigate();
    var _a = useState(""), cpf = _a[0], setCpf = _a[1];
    var _b = useState(""), renach = _b[0], setRenach = _b[1];
    var _c = useState(""), phoneNumber = _c[0], setPhoneNumber = _c[1];
    var _d = useState(null), ciretrans = _d[0], setCiretrans = _d[1];
    var _e = useState(""), idCiretran = _e[0], setIdCiretran = _e[1];
    var _f = useState(undefined), errorMessage = _f[0], setErrorMessage = _f[1];
    var _g = useState(false), cancelModal = _g[0], setCancelModal = _g[1];
    var getCiretranByCity = function (cities, idCidadePaisEndereco) {
        if (idCidadePaisEndereco) {
            var cidades = cities
                .filter(function (city) { return city.idCidadePais === idCidadePaisEndereco; })
                .flatMap(function (item) { return item.ciretranMunicipio; });
            if (cidades.length !== 0) {
                return cidades;
            }
            else {
                return cities.flatMap(function (city) { return city.ciretranMunicipio; });
            }
        }
        else {
            return cities.flatMap(function (city) { return city.ciretranMunicipio; });
        }
    };
    var handleSubmit = function () {
        var requestData = {
            phoneNumber: phoneNumber,
            idCiretran: idCiretran,
        };
        localStorage.setItem("pidRequestData", JSON.stringify(requestData));
        navigate("/habilitacao/resumo-processo-pid");
    };
    useEffect(function () {
        var pidRequestData = localStorage.getItem("pidRequestData");
        var fetchDriverData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, phoneNumber_1, error_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setErrorMessage(undefined);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        payload = {
                            cpf: "userInfo?.preferred_username",
                        };
                        return [4 /*yield*/, obterDadosCondutor(payload)];
                    case 2:
                        response = _d.sent();
                        setCpf(response.cpf);
                        setRenach(response.numeroRenach);
                        if (pidRequestData) {
                            phoneNumber_1 = JSON.parse(pidRequestData).phoneNumber;
                            setPhoneNumber(phoneNumber_1);
                        }
                        else {
                            setPhoneNumber(response.telefone);
                        }
                        fetchCities(response.ufEmissao, response.idCidadePaisEndereco);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        setErrorMessage((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Houve um erro ao recuperar dados do condutor.");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var fetchCities = function (uf, idCidadePaisEndereco) { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_2;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, obterCidades(uf)];
                    case 1:
                        response = _d.sent();
                        setCiretrans(getCiretranByCity(response, idCidadePaisEndereco));
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _d.sent();
                        setErrorMessage((_c = (_b = (_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Houve um erro ao listar as Ciretrans.");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (pidRequestData) {
            var idCiretran_1 = JSON.parse(pidRequestData).idCiretran;
            setIdCiretran(idCiretran_1);
        }
        fetchDriverData();
    }, [userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username]);
    return (_jsxs(_Fragment, { children: [_jsx(FixedMenu, { title: "Abertura do Processo PID", isHabilitacao: true }), _jsxs(Stack, __assign({ mt: "16rem" }, { children: [_jsx(HorizontalStepper, { steps: steps, activeStep: 0 }), _jsx(TituloPagina, { titulo: "Dados da Solicita\u00E7\u00E3o", subtitulo: "Preencha corretamente todos os campos para realizar a Solicita\u00E7\u00E3o de Abertura do Processo de Permiss\u00E3o Internacional para Dirigir (PID)." }), _jsxs(ContainerLayout, { children: [_jsxs(ContainerForm, __assign({ title: "Informa\u00E7\u00F5es Pessoais" }, { children: [_jsxs(Stack, __assign({ flexDirection: "row", justifyContent: "space-between", gap: "0.5rem" }, { children: [_jsx(TextField, { id: "cpf", label: "CPF", variant: "outlined", value: formatarCpf(cpf), slotProps: {
                                                    inputLabel: {
                                                        shrink: true,
                                                    },
                                                }, sx: { flex: 1 }, disabled: true }), _jsx(TextField, { id: "renach", label: "RENACH", variant: "outlined", value: renach, slotProps: {
                                                    inputLabel: {
                                                        shrink: true,
                                                    },
                                                }, sx: { flex: 1 }, disabled: true })] })), _jsx(TextField, { id: "phoneNumber", label: "Celular", variant: "outlined", value: formatarTelefone(phoneNumber), onChange: function (e) { return setPhoneNumber(formatarTelefone(e.target.value)); }, slotProps: {
                                            inputLabel: {
                                                shrink: true,
                                            },
                                            htmlInput: {
                                                maxLength: 11,
                                            },
                                        } })] })), _jsx(AlterarEndereco, { setInputAlterado: function () { return null; } }), ciretrans && (_jsx(ContainerForm, __assign({ title: "Dados do Processo", subtitle: "Selecione a unidade em que voc\u00EA deseja realizar a solicita\u00E7\u00E3o." }, { children: _jsx(TextField, __assign({ select: true, id: "idCiretran", label: "Ciretran", variant: "outlined", value: idCiretran, onChange: function (e) { return setIdCiretran(e.target.value); }, slotProps: {
                                        inputLabel: {
                                            shrink: true,
                                        },
                                    } }, { children: ciretrans.map(function (ciretran) { return (_jsx(MenuItem, __assign({ value: ciretran === null || ciretran === void 0 ? void 0 : ciretran.idCiretran }, { children: ciretran === null || ciretran === void 0 ? void 0 : ciretran.nomeCiretran }), ciretran === null || ciretran === void 0 ? void 0 : ciretran.idCiretran)); }) })) }))), _jsxs(Stack, __assign({ direction: { md: "row-reverse" }, marginY: "2rem", sx: { gap: "1rem" } }, { children: [_jsx(FormButton, { type: FormButtonType.PRIMARY, title: "Avan\u00E7ar", onClick: handleSubmit, isDisabled: !idCiretran || phoneNumber.length < 11 }), _jsx(FormButton, { type: FormButtonType.SECONDARY, title: "Cancelar", onClick: function () { return setCancelModal(true); } })] })), errorMessage && (_jsx(SnackbarFeedback, { isOpen: !!errorMessage, type: "error", message: errorMessage })), _jsx(Modal, { open: cancelModal, onClose: function () { return setCancelModal(false); }, title: "Cancelar solicita\u00E7\u00E3o", subTitle: "Deseja cancelar a solicita\u00E7\u00E3o da permiss\u00E3o internacional para dirigir (PID)?", buttons: [
                                    _jsx(FormButton, { type: FormButtonType.CANCEL_PRIMARY, title: "Sim", onClick: function () {
                                            localStorage.removeItem("pidRequestData");
                                            navigate("/home");
                                        } }),
                                    _jsx(FormButton, { type: FormButtonType.CANCEL_SECONDARY, title: "N\u00E3o", onClick: function () { return setCancelModal(false); } }),
                                ] })] })] }))] }));
};
